export const languages = {
  en: 'en'
}

export const translationResources = {
  [languages.en]: {
    // eslint-disable-next-line global-require
    translation: require('@percent/education-hosted-form/i18n/data/en.json')
  }
}
